import { Injectable } from '@angular/core';
import { BaseJsonService } from '@shared/services/base.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ListResponse } from '@shared/models';
import { OrderInvoice } from 'src/models/orders/invoice/order.invoice.model';


@Injectable({
	providedIn: 'root'
})
export class OrderInvoiceService extends BaseJsonService {

	getInvoicesFor(orderId: string): Observable<OrderInvoice[]> {
		const url = this.generateUrl(this.services.order, 'import/invoice/%s', orderId);

		return this.http.get<ListResponse<OrderInvoice>>(url, this.options).pipe(
			map((res: ListResponse<OrderInvoice>) => {
				// if (!res.data) {
				// 	return [
				// 		{
				// 			invoiceDate: Date.now().toString(),
				// 			invoiceNumber: '378543AB',
				// 			orderUuid: '123',
				// 			invoicePositions: [
				// 				{
				// 					invoicedQuantity: 12,
				// 					productNumber: '123SKU-Lang-123-123-123-123'
				// 				},
				// 				{
				// 					invoicedQuantity: 1,
				// 					productNumber: '123SKU-Kurz-123'
				// 				}
				// 			],
				// 		},
				// 		{
				// 			invoiceDate: Date.now().toString(),
				// 			invoiceNumber: 'RE78995423ABFG',
				// 			orderUuid: '456',
				// 			invoicePositions: [
				// 				{
				// 					invoicedQuantity: 23,
				// 					productNumber: 'G1345_0321000'
				// 				},
				// 				{
				// 					invoicedQuantity: 34,
				// 					productNumber: 'KLOWMNV-GIG-111'
				// 				}
				// 			],
				// 		}
				// 	];
				// }

				return res.data || [];
			})
		);
	}
}


